import { createSelector } from '@ngrx/store';
import { onlineOrderState } from '../root';

export const getOrderTrackingData = createSelector(onlineOrderState, (onlineOrder) => onlineOrder?.tracking?.data ?? null);
